import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { BlockDesktop as Block } from '@alfa-bank/site-block/desktop';
import { Grid } from '@alfa-bank/site-grid-universal';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';
import { createPageUrl } from '@alfa-bank/site-invest-mediaportal-common/helpers';
import { ImgV2 as Img } from '@alfa-bank/site-img-v2';
import { Link } from '@alfa-bank/site-link';
import { FontStyrene } from '@alfa-bank/site-font-styrene';

import type { INewsItemProps } from '../models';
import { getBannerInfo } from '../helpers';

import styles from './styles.css';

export const NewsItemDesktop: FC<INewsItemProps> = ({
    analytics,
    baseUrlToArticle,
    category,
    files,
    path,
    title,
}) => {
    const sendNewsAnalyticsByClick = () => {
        sendEvent({ ...analytics?.clickNews, label_detail: `${category.description} - ${title}` });
    };

    const banner = getBannerInfo(files);
    const columnsWidth = banner ? [null, 116] : [null];
    const pageUrl = createPageUrl(baseUrlToArticle, path);

    return (
        <Link
            className={cn(styles.external, styles.link)}
            dataTestId="headlines-news-item"
            href={pageUrl}
            noUnderline
            onClick={() => sendNewsAnalyticsByClick()}
        >
            <Block
                key={path}
                className={cn(styles.external, styles.wrapper)}
                notPadded
                styler={{ borderRadius: 24, padding: 24 }}
            >
                <Grid
                    alignment="center"
                    className={cn(styles.external, styles.fullHeight)}
                    collapse
                    columnsWidth={columnsWidth}
                    justify="between"
                >
                    <Grid
                        alignment="start"
                        colAutoWidth
                        collapse
                        flexDirection="column"
                        justify="start"
                    >
                        <Text kind="secondaryInverted" styler={{ margin: 0 }} view="primary-medium">
                            {category.description}
                        </Text>
                        <FontStyrene>
                            <Text
                                className={cn(styles.external, styles.headline)}
                                kind="primaryInverted"
                                styler={{ marginTop: 8 }}
                                tag="span"
                                view="accent-primary-large"
                            >
                                {title}
                            </Text>
                        </FontStyrene>
                    </Grid>
                    {banner && (
                        <Img
                            alt={banner.name}
                            className={cn(styles.external, styles.image)}
                            height={92}
                            src={banner.link}
                            styler={{ marginLeft: 24 }}
                            width={92}
                        />
                    )}
                </Grid>
            </Block>
        </Link>
    );
};
